import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { LoggedIn } from '../../../stores/auth/actions';
import { useNavigate } from 'react-router-dom';
import Button from '../../../PublicSide/components/Button/Button';
import Input from '../../../PublicSide/components/Input/Input';
import SuccessErrorMessage from '../../components/SuccesErrorMessage/SuccessErrorMessage';
import { StyledContainerLoginPasswordPage, StyledFormLoginPasswordPage } from '../../../style/GlobalsComponentsStyled';
import ServiceLocator from '../../../services/ServiceLocator';
import { Constants } from '../../../api/Configuration';
import { HandleError, ShowErrorMessage } from '../../../stores/page/actions';
import { ApiGetUserProfile } from '../../../stores/api/user/actions';
import { useAppDispatch } from '../../../helpers/UseAppDispatch';
import ErrorCode from '../../../api/dtos/ErrorCode';

const LoginPage: React.FC = () => {
    const dispatch = useAppDispatch();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const Navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('auth:refreshToken');
        if (token) {
            Navigate('/dashboard');
        }
    }, [Navigate]);
    
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setErrorMessage('');
        if (!email || !password) {
            setErrorMessage('Please fill in all fields.');
            return;
        }
        const response = await ServiceLocator.AuthService.Login({
            email: email,
            password: password,
            client_id: Constants.CLIENT_ID,
        });
        
        if (response.is_success) {
            dispatch(LoggedIn(response.data));
            dispatch(ApiGetUserProfile());
            Navigate('/dashboard');
        }
        else if (response.error_code === ErrorCode.INVALID_CREDENTIALS) {
            dispatch(ShowErrorMessage(response.error_message ?? 'Invalid email or password'));
        }
        else {
            dispatch(HandleError(response));
        }
    };

    return (
        <StyledContainerLoginPasswordPage as='main'>
            <Typography component='h1' variant='h2'>Connexion</Typography>
            <SuccessErrorMessage errorMessage={errorMessage} onClear={() => { setErrorMessage(''); }} />
            <StyledFormLoginPasswordPage as='form' onSubmit={handleSubmit} noValidate>
                <Input label='Email' type='email' name='email' value={email} onChange={(e) => setEmail(e.target.value)} required />
                <Input label='Password' type='password' name='password' value={password} onChange={(e) => setPassword(e.target.value)} required />
                <Button type='submit' text='Log In' />
            </StyledFormLoginPasswordPage>
        </StyledContainerLoginPasswordPage>
    );
};

export default LoginPage;
